import { render, staticRenderFns } from "./CareerPage.vue?vue&type=template&id=3affead0&"
import script from "./CareerPage.vue?vue&type=script&lang=js&"
export * from "./CareerPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports